import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

export default function AuthWrapper(): JSX.Element {
  const location = useLocation();

  const title =
    location.pathname === '/forgot'
      ? 'Password forgot'
      : location.pathname === '/signup'
        ? 'Register a Daytopper account'
        : 'Daytopper Login';

  return (
    <div className='flex justify-center items-center grow'>
      <div className='w-full sm:w-2/3 lg:w-1/3 sm:rounded-md p-5 space-y-6'>
        <h1 className='font-semibold text-xl text-gray-700 dark:text-gray-300'>{title}</h1>
        <Outlet />
      </div>
    </div>
  );
}
